import { render, staticRenderFns } from "./AtrialFibrillationSymptomScore.vue?vue&type=template&id=6fd40f1d&scoped=true&"
import script from "./AtrialFibrillationSymptomScore.vue?vue&type=script&lang=js&"
export * from "./AtrialFibrillationSymptomScore.vue?vue&type=script&lang=js&"
import style0 from "./AtrialFibrillationSymptomScore.vue?vue&type=style&index=0&id=6fd40f1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd40f1d",
  null
  
)

export default component.exports